export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-15.jpg'),
        title: 'グローバリゼーション/ローカリゼーション',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: 'グローバリゼーション/ローカリゼーション',
      description: `<p style="font-size:1.05rem">MaesInfoは、世界的に著名な企業や大規模機関に対してスマートなITソリューションを提供する専門企業です。本社は「中国のソフトウェア都市」として知られる成都にあり、アプリケーション、モバイル、組込みソフトウェア等の開発、ITソリューション、QA/QC、システム統合、ソフトウェア保守およびITインフラ保守サービスを提供しています。また、データ入力・処理・クレンジング、コールサービスを含むビジネスプロセスアウトソーシングや人材育成サービスもワンストップで支援します。改革開放政策や各級政府・関係各所の支援により、MaesInfoは近年安定した成長を続けており、深圳、常州、西安に支社を展開しています。</p>`
    },
    {
      title: 'グローバル化：',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-15.jpg')+`)"></span>
      <span>MaesInfoは米国のマウンテンビュー（Mountain View）およびピッツバーグ（Pittsburgh）にマーケットおよびプロジェクト管理拠点を有しています。人材面ではグローバルに優秀な技術・専門人材を採用しており、現在の従業員は中国、インド、アメリカ、カナダ、フィリピン、香港等多くの国と地域から集まっています。</span>`
    }
  ]
}
